import React, { useState, useEffect } from 'react'

import {
  Stack,
  Input,
  InputGroup,
  InputRightElement,
  Checkbox,
  CheckboxGroup,
  Divider,
} from '@chakra-ui/react'

import theme from '../../../../../Config/theme'

import { FaSearch } from 'react-icons/fa'

import statesData from '../../../../../Config/json/us_states.json'

const FilterState = ({ state }) => {

  const [states, setStates] = useState([])
  const { selectedStates, setSelectedStates } = state


  const handleSearch = (e) => {
    const search = e.target.value

    setStates(statesData.filter(state => state.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())))
  }

  const handleClick = (e) => {
    // Check if item is already selected to remove it
    const index = selectedStates.indexOf(e.target.value)

    if (index !== -1) {
      setSelectedStates(selectedStates.filter(state => state !== e.target.value))
      return
    }

    setSelectedStates([...selectedStates, e.target.value])
  }

  useEffect(() => {
    // Set states data from json file
    setStates(statesData)
  }, [])

  return (
    <Stack direction={'column'} maxH={'300px'}>
      <InputGroup>
        <InputRightElement children={<FaSearch />} />
        <Input
          placeholder={'Search state'}
          focusBorderColor={theme.default.defaultColor}
          //value={search}
          onChange={handleSearch}
        />
      </InputGroup>
      <CheckboxGroup colorScheme={'daddysteach'} defaultValue={selectedStates}>
        <Stack direction={'column'} overflow={'scroll'} overflowX={'hidden'}>
          <Checkbox size={'lg'} value={'nationwide'} onChange={handleClick}>Nationwide</Checkbox>
          <Divider />
          {
            states.map(state => {
              return (
                <Checkbox size={'lg'} key={state.abbreviation} value={state.abbreviation} onChange={handleClick}>{state.name}</Checkbox>
              )
            })
          }
        </Stack>
      </CheckboxGroup>
    </Stack>
  )
}

export default FilterState